import React from 'react';
import { SearchResult } from '../redux/api-slice';
import { useAppSelector } from '../redux/hooks'

export default function ResultAll(result: SearchResult) {
    const presentationNoun = useAppSelector((state) => state.pageSettings.presentationNoun);
    const linkLabel = useAppSelector((state) => state.pageSettings.linkLabel);
    return (
        <li className="performance-search-result performance-search-result-all" key={result.operaId} >
            <p className="performance-search-result-composer"> {result.composerName}</p>
            <div className="performance-search-result-content align-center">
                <div className="performance-search-result-title align-center">
                    <h3 className="h4-style"> {result.operaTitle} </h3>
                    <span className="performance-search-result-pronoun"> {result.presentationCount} {presentationNoun}{result.presentationCount > 1 ? "s" : ""} </span>
                </div>
                <div className="performance-search-result-link">
                    <a className="btn" href={result.detailPageUrl}>{linkLabel}</a>
                </div>
            </div>
        </li>
    );
}
